__turbopack_context__.v({
  "buyMetaStack": "index-module__wD17sa__buyMetaStack",
  "buySection": "index-module__wD17sa__buySection",
  "disclaimerButton": "index-module__wD17sa__disclaimerButton",
  "disclaimerButtonContainer": "index-module__wD17sa__disclaimerButtonContainer",
  "heightOpacityIn": "index-module__wD17sa__heightOpacityIn",
  "largePrompt": "index-module__wD17sa__largePrompt",
  "learnMoreButton": "index-module__wD17sa__learnMoreButton",
  "leftPanel": "index-module__wD17sa__leftPanel",
  "mobileCarouselSection": "index-module__wD17sa__mobileCarouselSection",
  "notServicableMessageContainer": "index-module__wD17sa__notServicableMessageContainer",
  "powerPlugSubsection": "index-module__wD17sa__powerPlugSubsection",
  "priceContentContainer": "index-module__wD17sa__priceContentContainer",
  "rightPanel": "index-module__wD17sa__rightPanel",
  "root": "index-module__wD17sa__root",
  "section": "index-module__wD17sa__section",
  "separator": "index-module__wD17sa__separator",
  "sizeInfoModal": "index-module__wD17sa__sizeInfoModal",
  "stickyPanel": "index-module__wD17sa__stickyPanel",
});
